import { DEL, GET, POST, PUT, setAuthToken } from "../config/ApiConfig";
import { apiError } from "../helpers/ErrorHelper";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const module = {
  endPoint: "/client-branches",
  key: "client_branches",
};

export const create = async (user_token, formData) => {
  setAuthToken(user_token);
  return await POST(`${module.endPoint}/add`, formData);
};

export const update = async (user_token, id, formData) => {
  setAuthToken(user_token);
  return await PUT(`${module.endPoint}/update/${id}`, formData);
};

export const remove = async (user_token, id) => {
  setAuthToken(user_token);
  return await DEL(`${module.endPoint}/delete/${id}`);
};

export const getData = async (param = {}) => {
  const user_token = param.user_token;
  if (!user_token) {
    return {};
  }

  const page = param.page ? param.page : 1;
  const limit = param.limit ? param.limit : -1;

  delete param.page;
  delete param.limit;
  const query = new URLSearchParams(param).toString();

  try {
    setAuthToken(user_token);
    const url = `${module.endPoint}/list?page=${page}&limit=${limit}&${query}`;
    const response = await GET(url);
    if (!response.status) {
      toast.error(response.message);
    }
    return response.data;
  } catch (error) {
    apiError(error);
    console.log(error);
    return {};
  }
};
